import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ConfirmpasswordComponent } from './confirmpassword/confirmpassword.component';
import { HomeComponent } from './home/home.component';
import { ForgottenPasswordComponent } from './forgotten-password/forgotten-password.component';
import { AuthorizationGuard } from './shared/guards/authorization.guard';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { ConfirmpasswordSucessComponent } from './confirmpasswordsucess/confirmpasswordsucess.component';

const APP_ROUTES: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        data: { title: "Login" }
    },
    {
        path: 'forgotten-password',
        component: ForgottenPasswordComponent,
        data: { title: "Forgotten Password" }
    },
    {
        path: 'confirmpassword',
        component: ConfirmpasswordComponent,
        data: { title: "Confirm Password" }
    },
    {
        path: 'confirmpasswordsuccess',
        component: ConfirmpasswordSucessComponent,
        data: { title: "Confirm Password Success" }
    },

    
    {
        path: 'createaccount',
        component: CreateAccountComponent,
        data: { title: "Create Account" }
    },
 {
        path: 'thankyou',
        component: ThankyouComponent,
        data: { title: "Thank You" }
    },    
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: "**",
        redirectTo: 'notfound',
        pathMatch: 'full'
    }
];

export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts